import { render, staticRenderFns } from "./mem_inside_land.vue?vue&type=template&id=2e6ac2c2&scoped=true&"
import script from "./mem_inside_land.vue?vue&type=script&lang=js&"
export * from "./mem_inside_land.vue?vue&type=script&lang=js&"
import style0 from "./mem_inside_land.vue?vue&type=style&index=0&id=2e6ac2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ac2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6ac2c2')) {
      api.createRecord('2e6ac2c2', component.options)
    } else {
      api.reload('2e6ac2c2', component.options)
    }
    module.hot.accept("./mem_inside_land.vue?vue&type=template&id=2e6ac2c2&scoped=true&", function () {
      api.rerender('2e6ac2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/land/mem_inside_land.vue"
export default component.exports